module.exports = "<app-menu></app-menu>\n"